import { useState, useEffect } from 'react';
import { getActiveApplication } from 'api';

export const useFetchApplications = (onUpdate = false) => {
  const [isLoading, setIsLoading] = useState(true);
  const [triggerFetch, setTriggerFetch] = useState(true);
  const [activeApplication, setActiveApplication] = useState<any>(null);
  const [isNotFound, setIsNotFound] = useState(false);

  useEffect(() => {
    let stillMounted = true;

    if (onUpdate || triggerFetch) {
      const getData = async () => {
        try {
          const data = await getActiveApplication();
          if (!stillMounted) {
            return;
          }
          setActiveApplication(data);
          setIsNotFound(false);
          setIsLoading(false);
        } catch (error) {
          if (!stillMounted) {
            return;
          }
          const statusCode = (error as { status_code?: string })?.status_code;
          setIsNotFound(statusCode === 'not_found');
          setIsLoading(false);
        }
      };

      if (triggerFetch) {
        setTriggerFetch(false);
      }

      if (stillMounted) {
        getData();
      }
    }

    return () => {
      stillMounted = false;
    };
  }, [onUpdate]);

  return { isLoading, activeApplication, isNotFound };
};
